<template>
  <div>
    <Header :title="title" :showBack="true"></Header>
    <!-- <div class="LineClassPicker">
      <van-cell icon="logistics" title="路线" :value="LineName" />
      <van-cell icon="clock-o" title="始发时间" :value="LineClassDayName" />
    </div> -->
    <van-popup v-model="showVehicleNoPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="VehicleNoList"
        @cancel="onCancelVehicleNoPicker"
        @confirm="onConfirmVehicleNoPicker"
        :loading="showVehicleNoPickerLoading"
      />
    </van-popup>
    <van-popup v-model="showDriverPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="DriverList"
        @cancel="onCancelDriverPicker"
        @confirm="onConfirmDriverPicker"
        :loading="showDriverLoading"
      />
    </van-popup>

    <!-- 跟车员 start -->
    <carFollowerPicker
      ref="carFollowerPicker"
      @handlerCarFollowerPicker="handlerCarFollowerPicker"
    ></carFollowerPicker>
    <!-- 跟车员 end  -->

    <van-popup v-model="showSignBoardNumberPicker" position="bottom">
      <van-picker
        :columns="SignBoardNumberList"
        show-toolbar
        @cancel="onCancelSignBoardNumberPicker"
        @confirm="onConfirmSignBoardNumberPicker"
      >
        <div slot="title">
          <van-search
            v-model="searchSignBoardNumberValue"
            placeholder="请输入线路标志牌号码"
            input-align="center"
          />
        </div>
        <div slot="confirm">
          <van-icon name="success" color="orange" size="28" />
        </div>
        <div slot="cancel">
          <van-icon name="cross" color="red" size="28" />
        </div>
      </van-picker>
    </van-popup>
    <div>
      <van-tabs
        style="width: 95%; margin: 10px auto"
        @click="onClickTabs"
        v-model="index"
        :lazy-render="false"
        :color="$store.state.baseColor"
      >
        <van-tab
          v-for="(item, ind) in LineClassDayVehicleDriverList"
          :key="item.GID"
          :title="item.VehicleNo"
        >
          <!-- 车辆信息 -->
          <van-cell-group title="车辆信息">
            <van-search
              v-model="VehicleNo"
              placeholder="请输入搜索车牌号"
              show-action
              shape="round"
              @search="onSearchNo"
              v-if="!item.CheckInTime"
            >
              <div slot="action" @click="onSearchNo">搜索</div>
            </van-search>
            <van-cell
              title="车牌号码"
              title-class="Title-CellClass"
              value-class="Value-CellClass"
              :value="item.VehicleNo"
            >
            </van-cell>
            <van-cell
              style="display: flex; justify-content: space-between"
              title="运输企业"
              title-class="Title-CellClass"
              v-if="[1, 2, 5, 6].indexOf(line.lineInfo.CustomMadeLevel) > -1"
            >
              <template slot="right-icon">
                <van-tag
                  style
                  v-if="item.BusinessUnit != null"
                  type="success"
                  class="tagQuInfo"
                  >{{ item.BusinessUnit.substring(0, 12) }}</van-tag
                >
                <van-icon v-else name="cross" color="red" />
              </template>
            </van-cell>
            <van-search
              v-model="SignBoardNumber"
              placeholder="请输入搜索标志牌号"
              show-action
              shape="round"
              @search="onSearchSignBoardNumber"
              v-if="!item.CheckInTime"
            >
              <div slot="action" @click="onSearchSignBoardNumber">搜索</div>
            </van-search>
            <van-cell
              title="标志牌号"
              title-class="Title-CellClass"
              value-class="Value-CellClass"
              :value="item.SignBoardNumber"
            ></van-cell>
            <!-- <van-cell
              title="道路运输证"
              title-class="Title-CellClass"
              v-if="[1, 2, 5, 6].indexOf(line.lineInfo.CustomMadeLevel) > -1"
            >
              <template slot="right-icon">
                <van-tag
                  v-if="item.Qualifications != null"
                  type="success"
                  class="tagQuInfo"
                  >{{ item.Qualifications.DaoLuYunShuZhengHao }}</van-tag
                >
                <van-icon v-else name="cross" color="red" />
              </template>
            </van-cell> -->
            <!-- <van-cell
              title="客运标志牌"
              title-class="Title-CellClass"
              v-if="[1, 2, 5, 6].indexOf(line.lineInfo.CustomMadeLevel) > -1"
            >
              <template slot="right-icon">
                <van-tag
                  v-if="item.Qualifications != null"
                  type="success"
                  class="tagQuInfo"
                  >{{ item.Qualifications.JingYingFanWei }}</van-tag
                >
                <van-icon v-else name="cross" color="red" />
              </template>
            </van-cell> -->
            <!-- <van-cell
              title="审核有效期"
              title-class="Title-CellClass"
              v-if="[1, 2, 5, 6].indexOf(line.lineInfo.CustomMadeLevel) > -1"
            >
              <template slot="right-icon">
                <van-tag
                  v-if="item.Qualifications != null"
                  :type="
                    item.Qualifications.ShenYanYouXiaoQi <
                    lineClassDay.ClassDate
                      ? 'danger'
                      : 'success'
                  "
                  class="tagQuInfo"
                  >{{ item.Qualifications.ShenYanYouXiaoQi }}</van-tag
                >
                <van-icon v-else name="cross" color="red" />
              </template>
            </van-cell> -->
            <van-cell
              title="安检情况"
              title-class="Title-CellClass"
              v-if="openType == 'SignIn'"
              max-size
            >
              <van-uploader
                class="uploadBox"
                :after-read="onReadImg"
                :disabled="item.CheckInTime ? true : false"
                accept="image/*"
                multiple
              >
                <span>点击上传照片</span>
                <van-icon class="uploadIcon" name="photograph" />
              </van-uploader>
            </van-cell>
            <img :src="item.CheckImgPath" style="width: 90%" />
            <van-cell
              title="定位校验"
              title-class="Title-CellClass"
              v-if="openType == 'SignIn'"
            >
              <template slot="right-icon">
                <van-tag v-if="item.s != null && item.s < 2" type="success"
                  >{{ item.s }}千米</van-tag
                >
                <van-tag v-if="item.s != null && item.s > 2" type="danger"
                  >{{ item.s }}千米</van-tag
                >
                <van-icon v-else name="cross" color="red" />
              </template>
            </van-cell>
            <van-field
              :style="{
                fontSize: '0.5rem',
                textAlign: 'left',
                color: $store.state.baseColor,
              }"
              label-align="left"
              label="定位失败"
              v-model="item.GPSErrorMsg"
              placeholder="请输入定位失败原因"
              v-if="
                openType == 'SignIn' &&
                (item.s > 2 || item.CheckInTime || item.s == null)
              "
              :readonly="item.CheckInTime ? true : false"
            />
          </van-cell-group>
          <!-- 司机信息 -->
          <van-cell-group class="driver-info" title="司机信息">
            <van-tabs
              class="driver-box"
              type="card"
              swipeable
              animated
              style="z-index: 0"
              :color="$store.state.baseColor"
            >
              <van-tab title="主司机">
                <van-search
                  v-model="DriverNameOrTel"
                  placeholder="请输入搜索司机"
                  show-action
                  shape="round"
                  @search="onSearchDriver(1)"
                  v-if="!item.CheckInTime"
                >
                  <div slot="action" @click="onSearchDriver(1)">搜索</div>
                </van-search>
                <van-cell
                  title="姓名"
                  title-class="Title-CellClass"
                  value-class="Value-CellClass"
                  :value="item.Driver1Name"
                ></van-cell>
                <van-cell
                  title="手机号"
                  title-class="Title-CellClass"
                  value-class="Value-CellClass"
                  :value="item.Driver1Tel"
                ></van-cell>
                <van-cell
                  title="从业资格证"
                  title-class="Title-CellClass"
                  value-class="Value-CellClass"
                  :value="item.Driver1IndustryCertNo"
                ></van-cell>
              </van-tab>
              <van-tab title="副司机">
                <van-search
                  v-model="Driver2NameOrTel"
                  placeholder="请输入搜索司机"
                  show-action
                  shape="round"
                  @search="onSearchDriver(2)"
                  v-if="!item.CheckInTime"
                >
                  <div slot="action" @click="onSearchDriver(2)">搜索</div>
                </van-search>
                <van-cell
                  title="姓名"
                  title-class="Title-CellClass"
                  value-class="Value-CellClass"
                  :value="item.Driver2Name"
                ></van-cell>
                <van-cell
                  title="手机号"
                  title-class="Title-CellClass"
                  value-class="Value-CellClass"
                  :value="item.Driver2Tel"
                ></van-cell>
                <van-cell
                  title="从业资格证"
                  title-class="Title-CellClass"
                  value-class="Value-CellClass"
                  :value="item.Driver2IndustryCertNo"
                ></van-cell>
              </van-tab>
              <van-tab title="跟车员" style="backgound-color: red">
                <van-search
                  v-model.trim="CarFollowerName"
                  placeholder="请输入搜索跟车员"
                  show-action
                  shape="round"
                  @search="onSearchCarFollower(item)"
                  v-if="!item.CheckInTime"
                >
                  <div slot="action" @click="onSearchCarFollower(item)">
                    搜索
                  </div>
                </van-search>
                <div class="car-follower-list">
                  <div
                    class="car-follower-item"
                    v-for="(i, num) in item.CarFollowersList"
                    :key="i.GID"
                  >
                    <p>{{ i.name }}</p>
                    <p @click="clickTel(i.tel)">{{ i.tel }}</p>
                    <van-icon
                      name="cross"
                      @click="clickRemoveCarFollowers(ind, num)"
                    />
                  </div>
                  <div
                    class="car_follower_null"
                    v-if="
                      !item.CarFollowersList ||
                      item.CarFollowersList.length == 0
                    "
                  >
                    暂无跟车员
                  </div>
                </div>
              </van-tab>
            </van-tabs>
          </van-cell-group>

          <van-divider></van-divider>
          <!-- 行程车费 -->
          <van-field
            style="font-size: 0.5rem"
            :readonly="item.CheckInTime ? true : false"
            v-model="item.VehicleFare"
            type="number"
            label="行程车费"
            input-align="right"
          />
          <van-divider></van-divider>
          <van-checkbox-group
            v-model="item.CheckResult"
            v-if="openType == 'SignIn'"
            :disabled="!item.CheckInTime ? false : true"
          >
            <van-cell-group title="证件核验">
              <van-cell
                style="border-bottom: 1px solid #ccc"
                v-for="(ititle, i) in CheckList"
                clickable
                :key="i"
                :title="ititle"
                @click="toggleCheck(i)"
                title-class="Title-CellClass"
              >
                <van-checkbox
                  style="float: right"
                  ref="checkboxes"
                  :name="i"
                  checked-color="#1989fa"
                />
              </van-cell>
            </van-cell-group>
          </van-checkbox-group>

          <van-button
            v-if="!item.CheckInTime && openType != 'SignIn'"
            :type="isShowCyw ? 'warning' : 'danger'"
            size="large"
            @click="onDelCar"
            >移除车辆</van-button
          >
          <!-- <van-button
            v-if="item.CheckInTime != null && item.DepartTime == null"
            type="warning"
            size="large"
            @click="onCancelSignIn(item)"
          >
            取消签到
          </van-button> -->
          <van-button
            v-if="IsNewSignInMode ? item.StartCarTime : item.DepartTime"
            type="default"
            size="large"
            >已经发车
          </van-button>
        </van-tab>
        <van-tab v-if="openType != 'SignIn'" title="+"></van-tab>
      </van-tabs>

      <van-row class="footer-btn" type="flex" justify="space-around">
        <van-col span="10">
          <!--  v-if="openType!='SignIn' && !LineClassDayVehicleDriverList[index].CheckInTime" -->
          <van-button
            :style="{ backgroundColor: $store.state.baseColor, color: '#fff' }"
            :disabled="
              openType != 'SignIn' &&
              LineClassDayVehicleDriverList.length >= 1 &&
              LineClassDayVehicleDriverList[index].CheckInTime
            "
            size="large"
            @click="onYesToCar"
            >{{ openType == "SignIn" ? "签到" : "派车" }}</van-button
          >
        </van-col>
        <van-col span="10">
          <van-button type="default" size="large" @click="onCancelCar"
            >取消</van-button
          >
        </van-col>
      </van-row>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/Header/Header.vue";
import carFollowerPicker from "./components/car-follower-picker";

export default {
  components: {
    Header,
    carFollowerPicker,
  },
  data() {
    return {
      isShowCyw: window.localStorage.getItem("isShowCyw") !== "false",
      title: "车辆管理", //页面标题
      NewConwinAPIIsError: "0",
      line: JSON.parse(window.localStorage.getItem("line")), //选择的线路
      lineClassDay: JSON.parse(window.localStorage.getItem("lineClassDay")), //选择的班次

      LineClassDayVehicleDriverList: [], //班次车辆司机列表
      index: 0, //当前选中的车辆
      VehicleNo: "", //车牌号
      VehicleNoList: [], //车牌号查询集合
      showVehicleNoPicker: false, //显示车辆列表
      showVehicleNoPickerLoading: false, //车辆列表加载
      showDriverPicker: false, //显示司机列表
      DriverList: [], //司机查询集合
      DriverNameOrTel: "", //司机姓名或手机号
      Driver2NameOrTel: "", //副司机姓名或手机号
      showDriverLoading: false, //司机列表加载
      selectDriver: 0, //选中司机或副司机 1司机 2副司机
      showSignBoardNumberPicker: false,
      SignBoardNumberList: [],

      //CheckResult: [], //证件核验选中结果
      openType: this.$route.query.IsCheck, //签到或者派车 默认派车
      GID: this.$route.query.GID, //签到日班次车辆GID
      latitude: null, //经度
      longitude: null, //纬度
      IsNewSignInMode: this.$utils.getSysParams("IsNewSignInMode") == "1", //是否新签到模式
      CheckList: [
        "行驶证与车辆匹配且真实有效",
        "营运证与车辆匹配且真实有效",
        "跨省线路有出省资质证明",
        "驾驶证与司机匹配且真实有效",
        "资格证与司机匹配且真实有效",
      ], //证件核验集合

      SignBoardNumber: null,
      searchSignBoardNumberValue: null,
      IsHandheldShowStartArrivalStats:
        this.$utils.getSysParams("IsHandheldShowStartArrivalStats") == "1", // 是否显示上下车统计

      CarFollowerName: "", // 跟车员姓名
    };
  },
  watch: {
    //搜索\标志牌
    searchSignBoardNumberValue() {
      if (this.searchSignBoardNumberValue) {
        this.SignBoardNumberList = this.$utils.searchByRegExp(
          this.searchSignBoardNumberValue.toUpperCase(),
          this.OrgSignBoardNumberList,
          "text"
        );
      } else {
        this.SignBoardNumberList = this.OrgSignBoardNumberList;
      }
    },
  },
  methods: {
    // 跟车员 start
    // 选择器返回
    handlerCarFollowerPicker(data) {
      this.CarFollowerName = "";
      if (Array.isArray(data)) {
        // this.LineClassDayVehicleDriverList[this.index].CarFollowersList = data;
        this.$set(
          this.LineClassDayVehicleDriverList[this.index],
          "CarFollowersList",
          data
        );
      }
    },
    // 点击 跟车员搜索
    onSearchCarFollower(data) {
      let CarFollowersList = data.CarFollowersList || [];
      this.$refs.carFollowerPicker.init(CarFollowersList, this.CarFollowerName);
    },
    // 点击删除跟车员
    clickRemoveCarFollowers(ind, num) {
      let list = this.LineClassDayVehicleDriverList;
      list[ind].CarFollowersList.splice(num, 1);
    },

    // 点击手机号
    clickTel(data) {
      window.location.href = "tel:" + data;
    },
    // 跟车员 end

    //安检情况图片上传
    onReadImg(file) {
      //仅回调显示选择的图片 不上传 在车辆签到操作时才将图片转换并上传
      // this.LineClassDayVehicleDriverList[this.index].CheckImgPath =
      //   file.content;
      // 大于1.5MB的jpeg和png图片都缩小像素上传
      if (/\/(?:jpeg|png)/i.test(file.file.type) && file.file.size > 1500000) {
        // 创建Canvas对象(画布)
        let canvas = document.createElement("canvas");
        // 获取对应的CanvasRenderingContext2D对象(画笔)
        let context = canvas.getContext("2d");
        // 创建新的图片对象
        let img = new Image();
        // 指定图片的DataURL(图片的base64编码数据)
        img.src = file.content;
        // 监听浏览器加载图片完成，然后进行进行绘制
        img.onload = () => {
          // 指定canvas画布大小，该大小为最后生成图片的大小
          canvas.width = 400;
          canvas.height = 300;
          /* drawImage画布绘制的方法。(0,0)表示以Canvas画布左上角为起点，400，300是将图片按给定的像素进行缩小。
             如果不指定缩小的像素图片将以图片原始大小进行绘制，图片像素如果大于画布将会从左上角开始按画布大小部分绘制图片，最后的图片就是张局部图。*/

          context.drawImage(img, 0, 0, 400, 300);
          // 将绘制完成的图片重新转化为base64编码，file.file.type为图片类型，0.92为默认压缩质量
          file.content = canvas.toDataURL(file.file.type, 0.92);
          // 最后将base64编码的图片保存，留待上传。
          this.LineClassDayVehicleDriverList[this.index].CheckImgPath =
            file.content;
        };
      } else {
        // 不做处理的jpg和png直接保存
        this.LineClassDayVehicleDriverList[this.index].CheckImgPath =
          file.content;
      }
    },
    //取消签到
    onCancelSignIn(Vehicle) {
      this.$dialog
        .confirm({
          message: "确定要对该车辆取消签到吗？",
        })
        .then(() => {
          if (Vehicle.DepartTime != null) {
            this.$toast.fail("已经发车车辆不能修改");
            return;
          }
          Vehicle.CheckInTime = null;
          Vehicle.CheckInOperGID = null;
          Vehicle.VehicleCheckInGeocoder = null;
          Vehicle.GPSErrorMsg = null;
          Vehicle.CheckImgPath = null;
          Vehicle.CheckResult = [];
          Vehicle.ModifyGID = JSON.parse(
            window.localStorage.getItem("adminInfo")
          ).GID;
          Vehicle.ModifyCode = JSON.parse(
            window.localStorage.getItem("adminInfo")
          ).UserCode;
          Vehicle.ModifyName = JSON.parse(
            window.localStorage.getItem("adminInfo")
          ).UserName;
          let params = {
            _JsonText: JSON.stringify(Vehicle),
          };
          this.$http
            .post(
              this.$api.onLineClassDayVehicleDriverCancelSign,
              this.$qs.stringify(params)
            )
            .then((res) => {
              if (res.success) {
                this.$toast.success("车辆取消签到成功");
                this.$router.push({
                  name: "LineClassDay",
                  params: {
                    tabactive: this.IsHandheldShowStartArrivalStats ? 2 : 1,
                  },
                }); //active:1 表示跳转后显示车辆页
              }
            });
        })
        .catch(() => {
          // on cancel
        });
    },
    //证件核验
    toggleCheck(index) {
      this.$refs.checkboxes[index].toggle();
    },
    //删除派车
    onDelCar() {
      this.$dialog
        .confirm({
          message: "确定要删除该车辆吗？",
        })
        .then(() => {
          if (
            this.LineClassDayVehicleDriverList[this.index].DepartTime != null
          ) {
            //已经签到或发车车辆不允许删除
            this.$toast.fail("该车辆已经发车,请先作废合同取消发车");
            return;
          }
          if (
            this.LineClassDayVehicleDriverList[this.index].CheckInTime != null
          ) {
            //已经签到或发车车辆不允许删除
            this.$toast.fail("该车辆已经签到,请先取消签到");
            return;
          }
          if (this.LineClassDayVehicleDriverList[this.index].GID == null) {
            this.LineClassDayVehicleDriverList.splice(this.index, 1);
            if (this.index != 0) {
              this.index -= 1;
            }
            this.$toast.success("删除成功");
            if (this.LineClassDayVehicleDriverList.length <= 0) {
              this.onAddCar();
              this.index = 0;
            }
            return;
          }
          let params = {
            _JsonText: JSON.stringify({
              GID: this.LineClassDayVehicleDriverList[this.index].GID,
              ModifyGID: JSON.parse(window.localStorage.getItem("adminInfo"))
                .GID,
              ModifyCode: JSON.parse(window.localStorage.getItem("adminInfo"))
                .UserCode,
              ModifyName: JSON.parse(window.localStorage.getItem("adminInfo"))
                .UserName,
            }),
          };
          this.$http
            .post(
              this.$api.onLineClassDayVehicleDriverDel,
              this.$qs.stringify(params)
            )
            .then((res) => {
              if (res.success) {
                this.LineClassDayVehicleDriverList.splice(this.index, 1);
                if (this.index != 0) {
                  this.index -= 1;
                }
                this.$toast.success("删除成功");
                if (this.LineClassDayVehicleDriverList.length <= 0) {
                  this.onAddCar();
                  this.index = 0;
                }
              }
            });
        })
        .catch(() => {
          // on cancel
        });
    },
    //新增派车
    onAddCar() {
      this.LineClassDayVehicleDriverList.push({
        GID: null,
        VehicleGID: null,
        VehicleNo: "新增车辆",
        Driver1GID: null,
        Driver2GID: null,
        CheckInTime: null,
      });
      this.index = this.LineClassDayVehicleDriverList.length - 1;
      // let b = JSON.parse(JSON.stringify(this.LineClassDayVehicleDriverList));
      // this.LineClassDayVehicleDriverList = [];
      // this.LineClassDayVehicleDriverList = b;
    },
    //取消派车
    onCancelCar() {
      this.$router.push({
        name: "LineClassDay",
        params: { tabactive: this.IsHandheldShowStartArrivalStats ? 2 : 1 },
      }); //active:1 表示跳转后显示车辆页
    },
    //确定派车 签到
    onYesToCar() {
      let VehicleDriverJson = [];
      let VehicleNoList = [];
      let flag = true;
      let VehicleGIDList = [];
      //判断派车是否符合条件
      for (let i = 0; i < this.LineClassDayVehicleDriverList.length; i++) {
        let element = this.LineClassDayVehicleDriverList[i];
        VehicleGIDList.push(element.VehicleGID);
        //如果已经签到 或发车 则跳过不再提交
        if (element.CheckInTime != null) {
          continue;
        }
        //如果是签到 判断证件是否核验
        if (this.openType == "SignIn") {
          // if ([3, 4].indexOf(this.line.lineInfo.CustomMadeLevel) > -1) {
          //   this.$toast.fail("非省内定制包车线路,车辆无需签到");
          //   return;
          // }
          // if (this.NewConwinAPIIsError === "1") {
          //   this.$toast.fail("省厅接口异常,暂时无法签到");
          //   return;
          // }
          if (element.CheckResult == null) {
            flag = false;
            this.$toast.fail("请核验证件并确认");
            return;
          } else if (
            element.CheckResult.indexOf(0) == -1 ||
            element.CheckResult.indexOf(1) == -1 ||
            element.CheckResult.indexOf(3) == -1 ||
            element.CheckResult.indexOf(4) == -1
          ) {
            flag = false;
            this.$toast.fail("请核验证件并确认");
            return;
          }

          if (
            (element.s > 2 || element.s == null) &&
            element.GPSErrorMsg == null
          ) {
            flag = false;
            this.$toast.fail("请填写定位失败原因");
            return;
          }
          if (element.CheckImgPath == null) {
            flag = false;
            this.$toast.fail("请上传安检情况图片");
            return;
          }
        }
        if (element.VehicleGID == null) {
          flag = false;
          this.$toast.fail("未指定车辆");
          return;
        }
        if (element.Driver1GID == null) {
          flag = false;
          this.$toast.fail("未指定司机");
          return;
        }
        if (this.NewConwinAPIIsError === "1") {
          // element.Qualifications = {
          //   msg: "接口异常",
          // };
          element.VehicleYunZhengInfo = {};
        }
        if ([3, 4].indexOf(this.line.lineInfo.CustomMadeLevel) > -1) {
          // element.Qualifications = {
          //   msg: "非省内定制包车线路",
          // };
          element.VehicleYunZhengInfo = {};
        }
        // if (element.Qualifications == null) {
        //   flag = false;
        //   this.$toast.fail("存在校验未通过车辆");
        //   return;
        // }
        // if (this.openType === "SignIn") {
        //   if (typeof element.YunZhengExtendObject == "object") {
        //     element.YunZhengExtendObject = JSON.stringify(
        //       element.YunZhengExtendObject
        //     );
        //   }
        // }

        VehicleDriverJson.push({
          GID: element.GID,
          VehicleGID: element.VehicleGID,
          Driver1GID: element.Driver1GID,
          Driver2GID: element.Driver2GID,
          GPSErrorMsg: element.GPSErrorMsg,
          CheckImgPath: element.CheckImgPath,
          NowGPS: element.NowGPS,
          // Qualifications: JSON.stringify(element.YunZhengExtendObject),
          VehicleYunZhengInfo: JSON.stringify(element.VehicleYunZhengInfo),
          VehicleFare: element.VehicleFare ? element.VehicleFare : 0,
          SignBoardNumber: element.SignBoardNumber
            ? element.SignBoardNumber
            : this.SignBoardNumber,

          // 跟车员 start
          CarFollowersGID: this.handlerCarFollowersGIDParam(
            element.CarFollowersList
          ),
          // 跟车员 end
        });
        VehicleNoList.push(element.VehicleNo);
      }
      if (!flag) {
        return;
      }
      if (VehicleDriverJson.length < 1) {
        this.$toast.fail("没有选择任何车辆信息");
        return;
      }

      let params = {
        LineClassDayGID: this.lineClassDay.GID,
        VehicleGIDList: VehicleGIDList.toString(),
      };
      this.$http
        .post(this.$api.onGetVehicleDriverSeatCount, this.$qs.stringify(params))
        .then((res) => {
          if (res.success) {
            if (
              res.data[0].PassengerSeatCount >= res.data[0].SeatCount &&
              res.data[0].PassengerSeatCount / 10 < res.data[0].IsChildCount
            ) {
              //提醒用户
              this.$dialog
                .confirm({
                  message: "该班次车辆免票座位数小于免票儿童数,是否继续派车",
                })
                .then(() => {
                  //继续执行操作
                  this.confirmYesToCar(VehicleNoList, VehicleDriverJson);
                })
                .catch(() => {
                  return;
                  // 取消派车
                });
            }
          }
        });
      this.confirmYesToCar(VehicleNoList, VehicleDriverJson);
    },

    // 处理跟车员请求参数
    handlerCarFollowersGIDParam(list) {
      if (!list) {
        return "";
      }
      let temp = [];
      list.forEach((it) => {
        temp.push(it.GID);
      });
      return temp.join(",");
    },

    //确认签到派车
    confirmYesToCar(VehicleNoList, VehicleDriverJson) {
      this.$dialog
        .confirm({
          message: "是否对车辆" + VehicleNoList.toString() + "进行操作",
        })
        .then(() => {
          let params = {
            LineClassDayGID: this.lineClassDay.GID,
            VehicleDriverJson: JSON.stringify(VehicleDriverJson),
            LineClassDayState: this.openType == "SignIn" ? 1 : 0,
            OperGID: JSON.parse(window.localStorage.getItem("adminInfo")).GID,
            OperCode: JSON.parse(window.localStorage.getItem("adminInfo"))
              .UserCode,
            OperName: JSON.parse(window.localStorage.getItem("adminInfo"))
              .UserName,
          };
          let flag = false;
          if (this.openType === "SignIn") {
            flag = true;
          }
          if (window._exceptionlessClient) {
            window._exceptionlessClient
              .createFeatureUsage(this.openType == "SignIn" ? "签到" : "派车")
              .setProperty("recordData", params)
              .submit();
          }
          this.$http
            .post(this.$api.onLineClassDayVehicleDriverBatchSave, {
              model: params,
              isMobile: flag,
            })
            .then((res) => {
              if (res.success) {
                let msg = "";
                // if (this.openType == "SignIn") {
                //   msg = "签到成功!";
                // } else {
                //   msg = "派车成功!";
                // }
                if (res.data[0].datamsg) {
                  this.$dialog
                    .alert({
                      message: msg + " 注意:" + res.data[0].datamsg,
                    })
                    .then(() => {
                      this.$router.back(-1);
                    });
                } else {
                  this.$toast.success(msg);
                  this.$router.back(-1);
                }

                // this.$router.back(-1);
                //this.$router.push({
                //  name: "LineClassDay",
                //  params: { tabactive: 1 }
                //}); //active:1 表示跳转后显示车辆页
              } else {
                // if (res.msg.indexOf("定制客运备案") > 0) {
                //   this.$dialog
                //     .alert({
                //       message: res.msg,
                //     })
                //     .then(() => {
                //       var parm = [];
                //       VehicleDriverJson.forEach((d) => {
                //         parm.push({
                //           LineClassDayGID: this.lineClassDay.GID,
                //           SignBoardNumber: d.SignBoardNumber,
                //           VehicleGID: d.VehicleGID,
                //           Driver1GID: d.Driver1GID,
                //           Driver2GID: d.Driver2GID,
                //           ModifyGID: JSON.parse(
                //             window.localStorage.getItem("adminInfo")
                //           ).GID,
                //           ModifyCode: JSON.parse(
                //             window.localStorage.getItem("adminInfo")
                //           ).UserCode,
                //           ModifyName: JSON.parse(
                //             window.localStorage.getItem("adminInfo")
                //           ).UserName,
                //         });
                //       });
                //       this.$http
                //         .post(
                //           this.$api
                //             .onLineClassDayVehicleDriverErrorRecordCreate,
                //           this.$qs.stringify({
                //             _JsonText: JSON.stringify(parm),
                //           })
                //         )
                //         .then((res) => {
                //           if (res.success) {
                //             this.$toast.success("提交派车申请成功");
                //           } else {
                //             this.$toast.fail("提交派车申请失败");
                //           }
                //         });
                //     });
                // }
              }
            });
        })
        .catch(() => {
          // on cancel
        });
    },
    //选择车辆
    onClickTabs(name, title) {
      this.index = name;

      // 跟车员 start
      this.CarFollowerName = "";
      // 跟车员 end

      if (title == "+") {
        this.onAddCar();
      }
      // if (title == "-") {
      //   this.onDelCar();
      // }
    },
    //司机搜索
    onSearchDriver(driver) {
      this.showDriverPicker = true;
      this.showDriverLoading = true;
      this.DriverList = [];
      this.selectDriver = driver;
      let DriverNameOrTel = "";
      if (this.selectDriver == 1) {
        DriverNameOrTel = this.DriverNameOrTel;
      } else if (this.selectDriver == 2) {
        DriverNameOrTel = this.Driver2NameOrTel;
      }
      let params = {
        CompGID: JSON.parse(window.localStorage.getItem("adminInfo")).CompGID,
        DriverNameOrTel: DriverNameOrTel,
      };
      this.$http
        .post(this.$api.onCompDriverQuery, this.$qs.stringify(params))
        .then((res) => {
          if (res.success) {
            for (let i = 0; i < res.data.length; i++) {
              this.DriverList.push({
                text: res.data[i].DriverName,
                keyID: res.data[i].DriverGID,
                industryCertNo: res.data[i].IndustryCertNo,
                IsVerified: res.data[i].IsVerified,
                driverCertNo: res.data[i].DriverCertNo,
                tel: res.data[i].DriverTel,
              });
            }
          }
          this.DriverNameOrTel = "";
          this.Driver2NameOrTel = "";
          this.showDriverLoading = false;
        });
    },
    //取消司机选择
    onCancelDriverPicker() {
      this.DriverList = [];
      this.DriverNameOrTel = "";
      this.Driver2NameOrTel = "";
      this.showDriverPicker = false;
    },
    //选中司机
    onConfirmDriverPicker(value) {
      if (value) {
        this.DriverList = [];
        this.DriverNameOrTel = "";
        this.Driver2NameOrTel = "";
        this.showDriverPicker = false;
        //如果是互联网包车 查询司机从业资格证是否一致
        //var flag = true;
        if (
          this.line.lineInfo.CustomMadeLevel == 1 &&
          (!value.industryCertNo || !value.IsVerified)
        ) {
          this.$toast.fail("司机未填写从业资格证！");
          return;
        } else {
          if (this.selectDriver == 1) {
            this.LineClassDayVehicleDriverList[this.index].Driver1GID =
              value.keyID;
            this.LineClassDayVehicleDriverList[this.index].Driver1Name =
              value.text;
            this.LineClassDayVehicleDriverList[this.index].Driver1Tel =
              value.tel;
            this.LineClassDayVehicleDriverList[
              this.index
            ].Driver1IndustryCertNo = value.industryCertNo;
          } else if (this.selectDriver == 2) {
            this.LineClassDayVehicleDriverList[this.index].Driver2GID =
              value.keyID;
            this.LineClassDayVehicleDriverList[this.index].Driver2Name =
              value.text;
            this.LineClassDayVehicleDriverList[this.index].Driver2Tel =
              value.tel;
            this.LineClassDayVehicleDriverList[
              this.index
            ].Driver2IndustryCertNo = value.industryCertNo;
          }
        }
      }
    },
    //选中车牌
    onConfirmVehicleNoPicker(value) {
      this.VehicleNoList = [];
      this.showVehicleNoPicker = false;
      this.LineClassDayVehicleDriverList[this.index].VehicleNo = value.vno;
      this.LineClassDayVehicleDriverList[this.index].VehicleGID = value.keyID;
      this.LineClassDayVehicleDriverList[this.index].CodeName = value.color;
      this.LineClassDayVehicleDriverList[this.index].YeHuDaiMa =
        value.data.YeHuDaiMa;
      this.LineClassDayVehicleDriverList[this.index].BusinessUnit =
        value.data.BusinessUnit;
      this.LineClassDayVehicleDriverList[this.index].VehicleGPSCode =
        value.VehicleGPSCode;
      this.VehicleNo = "";
      //查询资质
      // if (this.NewConwinAPIIsError === "1") {
      //   this.$toast.fail("省厅接口异常,暂时无法查询车辆资质,但可正常派车");
      //   return;
      // }
      //非定制线路不校验资质
      if ([3, 4].indexOf(this.line.lineInfo.CustomMadeLevel) > -1) {
        return;
      }
      this.onConwinVehicleQuery(
        this.LineClassDayVehicleDriverList[this.index],
        this.index
      );
    },
    //车牌搜索内容退出
    onCancelVehicleNoPicker() {
      this.VehicleNoList = [];
      this.VehicleNo = "";
      this.showVehicleNoPicker = false;
    },
    onCancelSignBoardNumberPicker() {
      this.SignBoardNumberList = [];
      this.SignBoardNumber = "";
      this.showSignBoardNumberPicker = false;
    },
    onConfirmSignBoardNumberPicker(value) {
      this.SignBoardNumberList = [];
      this.SignBoardNumber = "";
      this.showSignBoardNumberPicker = false;
      if (value) {
        // 证件到期提醒，判断是否有截止日期
        if (value.endValidDate) {
          let now = this.$moment(this.$moment(new Date()).format("YYYY-MM-DD"));
          let endValidDate = this.$moment(value.endValidDate);
          let diffDays = endValidDate.diff(now, "days") + 1;
          if (diffDays <= 0) {
            this.$dialog.alert({
              title: "证件到期提醒",
              message: `证件已于${endValidDate.format(
                "YYYY-MM-DD"
              )}过期，请注意及时报备新证件`,
            });
            return;
          } else if (diffDays <= 5) {
            this.$dialog.alert({
              title: "证件到期提醒",
              message: `证件${diffDays}天后即将过期，请注意及时报备新证件`,
            });
          }
          this.LineClassDayVehicleDriverList[this.index].SignBoardNumber =
            value.text;
        } else {
          this.LineClassDayVehicleDriverList[this.index].SignBoardNumber =
            value.text;
        }
      }
    },
    //标志牌搜索
    onSearchSignBoardNumber() {
      let vehicle = this.LineClassDayVehicleDriverList[this.index];
      if (!vehicle.VehicleGID) {
        this.$toast("请先选择车辆");
        return;
      }
      // if (this.SignBoardNumber.length < 3) {
      //   this.$toast("请至少输入三位数再查询");
      //   return;
      // }
      this.SignBoardNumberList = [];
      this.OrgSignBoardNumberList = [];
      // 判断是否省外车
      if (vehicle.VehicleNo.charAt(0) != "粤") {
        // 查询车辆资料
        let params = {
          VehicleGID: vehicle.VehicleGID,
          IsValid: true,
          CertType: "标志牌",
        };
        this.$http
          .post(this.$api.getVehicleCert, this.$qs.stringify(params))
          .then((res) => {
            if (res.success) {
              for (let i = 0; i < res.data.length; i++) {
                this.SignBoardNumberList.push({
                  text: res.data[i].SignNo,
                  keyID: res.data[i].SignNo,
                  endValidDate: res.data[i].EndValidDate,
                });
              }
              this.OrgSignBoardNumberList = this.SignBoardNumberList;
              this.showSignBoardNumberPicker = true;
            }
          });
      } else {
        // 查询运政接口
        let params = {
          YeHuDaiMa: vehicle.YeHuDaiMa,
          BiaoZhiPaiHaoMa: this.SignBoardNumber,
        };
        this.$http
          .post(this.$api.getSignBoardNumber, this.$qs.stringify(params))
          .then((res) => {
            if (res.success) {
              for (let i = 0; i < res.data.length; i++) {
                this.SignBoardNumberList.push({
                  text: res.data[i].BiaoZhiPaiHaoMa,
                  keyID: res.data[i].BiaoZhiPaiHaoMa,
                });
              }
              this.OrgSignBoardNumberList = this.SignBoardNumberList;
              this.showSignBoardNumberPicker = true;
            }
          });
      }
    },
    //车牌号搜索
    onSearchNo() {
      this.VehicleNoList = [];
      this.showVehicleNoPicker = true;
      this.showVehicleNoPickerLoading = true;
      let params = {
        CompGID: JSON.parse(window.localStorage.getItem("adminInfo")).CompGID,
        VehicleNo: this.VehicleNo,
        sort: "VehicleNo",
      };
      this.$http
        .post(this.$api.onCompVehicleQuery, this.$qs.stringify(params))
        .then((res) => {
          if (res.success) {
            for (let i = 0; i < res.data.length; i++) {
              this.VehicleNoList.push({
                text:
                  res.data[i].VehicleNo +
                  "-(" +
                  res.data[i].PassengerSeatCount +
                  ")",
                keyID: res.data[i].VehicleGID,
                color: res.data[i].CodeName,
                vno: res.data[i].VehicleNo,
                VehicleGPSCode: res.data[i].VehicleGPSCode,
                data: res.data[i],
              });
            }
          }
          this.showVehicleNoPickerLoading = false;
        });
    },
    //查询班次车辆数据
    onLineClassDayVehicleDriverQuery() {
      if (!this.lineClassDay.GID) {
        this.$toast("暂无数据");
        return;
      }
      let params;
      if (this.openType == "SignIn") {
        params = {
          GID: this.GID,
        };
      } else {
        params = {
          LineClassDayGID: this.lineClassDay.GID,
        };
      }
      this.$http
        .post(this.$api.getVehicleDriver, this.$qs.stringify(params))
        .then((res) => {
          if (res.success) {
            this.LineClassDayVehicleDriverList = [];
            this.LineClassDayVehicleDriverList = res.data;
            //车辆资质 GPS 查询
            if ([1, 2, 5, 6].indexOf(this.line.lineInfo.CustomMadeLevel) > -1) {
              for (
                let i = 0;
                i < this.LineClassDayVehicleDriverList.length;
                i++
              ) {
                if (!this.LineClassDayVehicleDriverList[i].Driver1GID) {
                  this.onConwinVehicleQuery(
                    this.LineClassDayVehicleDriverList[i],
                    i
                  );
                }
              }
            }

            this.LineClassDayVehicleDriverList.forEach((item) => {
              if (item.CheckInTime) {
                if (item.LineBusinessScopeName === "省际包车客运") {
                  item.CheckResult = [0, 1, 2, 3, 4];
                } else {
                  item.CheckResult = [0, 1, 3, 4];
                }
              }
            });
            if (this.LineClassDayVehicleDriverList.length < 1) {
              this.onAddCar();
              // this.LineClassDayVehicleDriverList.push({
              //   GID: null,
              //   VehicleGID: null,
              //   VehicleNo: "新增车辆",
              //   Driver1GID: null,
              //   Driver2GID: null
              // });
            }

            // 跟车员 start
            // 处理跟车人
            let tempList = this.LineClassDayVehicleDriverList;
            this.LineClassDayVehicleDriverList = tempList.map((item) => {
              if (item.CarFollowersGID) {
                let CarFollowersList = [];
                item.CarFollowersGID.split(",").forEach((it, ind) => {
                  let splitData =
                    item.CarFollowersName.split(",")[ind].split("(");
                  CarFollowersList.push({
                    GID: it,
                    name: splitData[0],
                    tel: splitData[1].split(")")[0],
                  });
                });
                return {
                  ...item,
                  CarFollowersList,
                };
              }
              return item;
            });
            // 跟车员 end
          }
        });
    },

    //车辆资质查询
    onConwinVehicleQuery(Vehicle, index) {
      //获取最近一次的派车记录
      // if (!Vehicle.SignBoardNumber) {
      // 2023-11-23 切换车辆也要重新加载司机
      this.$http
        .post(
          this.$api.getVehicleDriver,
          this.$qs.stringify({
            VehicleGID: Vehicle.VehicleGID,
            dir: "DESC",
            start: 0,
            limit: 1,
          })
        )
        .then((rs) => {
          if (rs.success && rs.data.length > 0) {
            if (rs.data[0].SignBoardNumber) {
              Vehicle.SignBoardNumber = rs.data[0].SignBoardNumber;
              this.showSignBoardNumberPicker = true;
              this.showSignBoardNumberPicker = false;
            }
            if (rs.data[0].Driver1GID) {
              Vehicle.Driver1GID = rs.data[0].Driver1GID;
              Vehicle.Driver1Tel = rs.data[0].Driver1Tel;
              Vehicle.Driver1IndustryCertNo = rs.data[0].Driver1IndustryCertNo;
              Vehicle.Driver1Name = rs.data[0].Driver1Name;
            }
          }
        });
      // }
      //签到查询GPS
      if (this.openType != "DispatchingCar") {
        let params = {
          VehicleGID: Vehicle.VehicleGID,
          VehicleNo: Vehicle.VehicleNo,
          VehicleNoColor: Vehicle.CodeName,
          QueryTypeList: "GPS",
        };
        this.$http
          .post(this.$api.onConwinVehicleQuery, this.$qs.stringify(params))
          .then((res) => {
            if (res.success) {
              //GPS接口返回失败
              if (!res.data.GPS.success) {
                this.$toast.fail("GPS接口异常,查询失败");
              } else {
                Vehicle.NowGPS =
                  res.data.GPS.data.Lat + "," + res.data.GPS.data.Lon;
                //获取手持机GPS定位并比对
                if (this.latitude != null && this.longitude != null) {
                  Vehicle.s = this.getFlatternDistance(
                    res.data.GPS.data.Lat,
                    res.data.GPS.data.Lon,
                    this.latitude,
                    this.longitude
                  );
                } else {
                  Vehicle.s = null;
                }
              }
            }
          });
      }
    },
    /*计算两经纬度点之间的距离(单位：米)*/
    getFlatternDistance: function (lat1, lng1, lat2, lng2) {
      /* @param lng1	经度1
       * @param lat1	纬度1
       * @param lng2	经度2
       * @param lat2	纬度2
       * @return 距离（米）
       * */
      var radLat1 = (lat1 * Math.PI) / 180.0;
      var radLat2 = (lat2 * Math.PI) / 180.0;
      var a = radLat1 - radLat2;
      var b = (lng1 * Math.PI) / 180.0 - (lng2 * Math.PI) / 180.0;
      var s =
        2 *
        Math.asin(
          Math.sqrt(
            Math.pow(Math.sin(a / 2), 2) +
              Math.cos(radLat1) *
                Math.cos(radLat2) *
                Math.pow(Math.sin(b / 2), 2)
          )
        );
      s = s * 6378.137;
      s = Math.round(s * 10000) / 1000;
      return s;
    },
  },
  mounted: function () {
    // if (window.framework) {
    //   // 请求机器定位
    //   window.framework.jsGeolocation();
    //   var fun = function(jsonObj) {
    //     //定位失败
    //     if (!jsonObj.success) {
    //       this.$toast.fail("定位失败!");
    //       return;
    //     }
    //     //经度
    //     this.latitude = jsonObj.data.latitude;
    //     //纬度
    //     this.longitude = jsonObj.data.longitude;
    //   };
    //   // 定位回调
    //   window.callGeolocation = fun.bind(this);
    // }
  },
  created() {
    this.onLineClassDayVehicleDriverQuery();
  },
};
</script>

<style scoped lang="less">
.Value-CellClass {
  font-size: 16px;
}

.Title-CellClass {
  text-align: left;
  font-size: 0.5rem;
  line-height: 0.875rem;
}

/deep/.van-tabs__wrap {
  margin-bottom: 0.26rem;
}

.van-tab {
  border-radius: 10px;
  overflow: hidden;
}

.van-tag {
  line-height: inherit;
}

.van-search {
  border-bottom: 1px solid #ccc;
  border-top: 1px solid #ccc;
}

.van-cell__value {
  color: #323233;
  line-height: 0.75rem;
}

.uploadBox > .uploadIcon {
  // 安检情况--上传照片
  position: relative;
  top: 0.0625rem;
  margin-left: 0.3125rem;
}

.van-checkbox__icon > .van-icon {
  // 图标
  line-height: 0.75rem;
  border: 1px solid red;
}

.van-cell-group__title {
  // 区块标题
  margin-bottom: 10px;
  font-size: 16px;
}

.van-hairline--top-bottom {
  border-radius: 5px;
  overflow: hidden;
}

.driver-info {
  // 司机信息
  padding-top: 0.3125rem;
  overflow: hidden;
}

// 跟车员 start
// 跟车人
.car-follower-list {
  background-color: #fff;
  min-height: 4.23rem;
  padding: 0 0.4rem;
  font-size: 0.46rem;

  .car-follower-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-align: left;
    padding: 0.3rem 0;
    border-bottom: 1px solid #f5f6f7;
    & > :nth-child(1) {
      width: 40%;
      overflow: hidden;
    }
    & > :nth-child(3) {
      font-size: 0.5rem;
      margin-left: 1rem;
    }
  }
  .car_follower_null {
    height: 4.23rem;
    line-height: 4.23rem;
    color: #969799;
    font-size: 0.42rem;
  }
}
// 跟车员 end

.van-checkbox {
  // 证件核验--右侧勾选图标
  margin-top: 0.5rem;
}

.footer-btn {
  margin-top: 0.5rem;
}

.LineClassPicker {
  width: 95%;
  margin: 0.3125rem auto;
  text-align: -webkit-auto;
}

.tagQuInfo {
  max-width: 5rem;
  max-height: 0.7rem;
}
</style>
